import MainContainer from "components/MainContainer";
import RenderHtmlComponent from "components/RenderHtml";
import { LegalScreenProps } from "navigation/types";
import { useFetchAgreementsQuery } from "queries/agreement.queries";
import React, { useEffect, useState } from "react";
import { View } from "react-native";

export default function Legal({ route }: LegalScreenProps) {
  const { documentName } = route.params;
  const { data: agreements } = useFetchAgreementsQuery("REGISTRATION");
  const [source, setSource] = useState("");

  useEffect(() => {
    if (!agreements) return;
    const agreement = agreements.find(
      (agrmnt) => agrmnt.title === decodeURIComponent(documentName)
    );

    setSource(agreement?.body || "");
  }, [agreements]);

  if (!agreements) return null;

  return (
    <MainContainer showHeader={false}>
      <View style={{ padding: 15 }}>
        <RenderHtmlComponent source={source} />
      </View>
    </MainContainer>
  );
}
